import { extendTheme } from '@chakra-ui/react';
import { CardComponent } from './additions/card/card';
import { buttonStyles } from './components/button';
import { badgeStyles } from './components/badge';
import { inputStyles } from './components/input';
import { progressStyles } from './components/progress';
import { sliderStyles } from './components/slider';
import { textareaStyles } from './components/textarea';
import { switchStyles } from './components/switch';
import { linkStyles } from './components/link';
import { breakpoints } from './foundations/breakpoints';
import { globalStyles } from './styles';
import { MultiSelectStyles } from './components/multiSelect';
import { skeletonStyles } from './components/skeleton';

export default extendTheme(
  {
    breakpoints,
    fonts: {
      heading: `'DM Sans', sans-serif`,
      body: `'DM Sans', sans-serif`,
      mono: `'DM Sans', sans-serif`,
    },
    fontWeights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeights: {
      none: 1,
      tight: 1.15,
      snug: 1.25,
      normal: 1.4,
      relaxed: 1.5,
    },
    textStyles: {
      kpi: {
        fontSize: { base: '28px', md: '32px' },
        fontWeight: '700',
        lineHeight: '1.1',
        letterSpacing: '-0.02em',
      },
      kpiLarge: {
        fontSize: { base: '34px', md: '40px' },
        fontWeight: '700',
        lineHeight: '1',
        letterSpacing: '-0.02em',
      },
      cardTitle: {
        fontSize: { base: '18px', md: '20px' },
        fontWeight: '600',
        lineHeight: '1.2',
        letterSpacing: '0',
      },
      sectionTitle: {
        fontSize: { base: '20px', md: '22px' },
        fontWeight: '700',
        lineHeight: '1.2',
        letterSpacing: '0',
      },
      label: {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '1.3',
        letterSpacing: '0',
      },
      tableHeader: {
        fontSize: '12px',
        fontWeight: '600',
        lineHeight: '1.3',
        letterSpacing: '0',
        textTransform: 'none',
      },
      tableCell: {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '1.4',
        letterSpacing: '0',
      },
    },
  },
  globalStyles,
  badgeStyles, // badge styles
  buttonStyles, // button styles
  linkStyles, // link styles
  progressStyles, // progress styles
  sliderStyles, // slider styles
  inputStyles, // input styles
  textareaStyles, // textarea styles
  switchStyles, // switch styles
  CardComponent, // card component
  MultiSelectStyles,
  skeletonStyles, // skeleton styles
);
